import { render, staticRenderFns } from "./EmployeeGrants.vue?vue&type=template&id=54b84c56&"
import script from "./EmployeeGrants.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports